import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle4 from "../../randing/RandingStyle4";

function Randing035({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/035/24122301.png`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/035/24122302.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/035/24122303.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/032/24121904.jpg`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/032/24121905.jpg`}
      benefitInfoPosition="bottom"
      formFieldColor="white"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/orange/ApplyBenefitButton.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/dlatl.jpg`}
    />
  );
}

export default Randing035;
